export default {
  path: '/retrieve',
  meta: {
    title: '修改密码',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/retrieve`),
}



// WEBPACK FOOTER //
// ./src/views/retrieve/router.js